import { TIPOS_OBJETO_TABLETOP, type TipoObjetoTabletop } from './tipos'

/** Quantos tipos recentes a bandeja sugere. */
export const MAXIMO_RECENTES = 6

/** Põe o tipo à frente da lista de recentes, sem repetir e sem passar do máximo. */
export function registrarRecente(
  recentes: readonly TipoObjetoTabletop[],
  tipo: TipoObjetoTabletop,
  maximo = MAXIMO_RECENTES,
): TipoObjetoTabletop[] {
  return [tipo, ...recentes.filter((item) => item !== tipo)].slice(0, maximo)
}

/** Lê a lista guardada (JSON), descartando o que não é um tipo conhecido. */
export function lerRecentes(bruto: string | null, maximo = MAXIMO_RECENTES): TipoObjetoTabletop[] {
  if (!bruto) return []
  try {
    const dados: unknown = JSON.parse(bruto)
    if (!Array.isArray(dados)) return []
    const conhecidos: readonly string[] = TIPOS_OBJETO_TABLETOP
    const vistos = new Set<string>()
    const saida: TipoObjetoTabletop[] = []
    for (const item of dados) {
      if (typeof item !== 'string' || !conhecidos.includes(item) || vistos.has(item)) continue
      vistos.add(item)
      saida.push(item as TipoObjetoTabletop)
    }
    return saida.slice(0, maximo)
  } catch {
    return []
  }
}
